
define('text!plugins/number/setupTemplate.html',[],function () { return '';});

